import { jsx as ie, jsxs as er } from "react/jsx-runtime";
import * as a from "react";
import tr, { useRef as x, useEffect as Mt, useState as Ie, memo as rr } from "react";
import { u as ae } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { IconContainer as nr } from "@biron-data/react-components";
import { r as ir, a as or, b as ar, d as xt, e as Ot, s as sr, u as ur, _ as P, f as ke, g as $e, w as mt, h as tt, i as F, j as Ne, k as N, l as U, m as ye, n as cr, o as lr, p as pt, q as gt } from "../../../raf-1AcQTkO6.js";
import { useLanguageResolver as fr } from "@biron-data/react-contexts";
function vr(e, t) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}
const dr = a.forwardRef(vr);
function Ue(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return tr.Children.forEach(e, function(n) {
    n == null && !t.keepEmpty || (Array.isArray(n) ? r = r.concat(Ue(n)) : ir.isFragment(n) && n.props ? r = r.concat(Ue(n.props.children, t)) : r.push(n));
  }), r;
}
var Ze = /* @__PURE__ */ a.createContext(null);
function hr(e) {
  var t = e.children, r = e.onBatchResize, n = a.useRef(0), i = a.useRef([]), o = a.useContext(Ze), s = a.useCallback(function(u, d, f) {
    n.current += 1;
    var p = n.current;
    i.current.push({
      size: u,
      element: d,
      data: f
    }), Promise.resolve().then(function() {
      p === n.current && (r == null || r(i.current), i.current = []);
    }), o == null || o(u, d, f);
  }, [r, o]);
  return /* @__PURE__ */ a.createElement(Ze.Provider, {
    value: s
  }, t);
}
var zt = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(i, o) {
      return i[0] === r ? (n = o, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var n = e(this.__entries__, r), i = this.__entries__[n];
        return i && i[1];
      }, t.prototype.set = function(r, n) {
        var i = e(this.__entries__, r);
        ~i ? this.__entries__[i][1] = n : this.__entries__.push([r, n]);
      }, t.prototype.delete = function(r) {
        var n = this.__entries__, i = e(n, r);
        ~i && n.splice(i, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var s = o[i];
          r.call(n, s[1], s[0]);
        }
      }, t;
    }()
  );
}(), Je = typeof window < "u" && typeof document < "u" && window.document === document, Pe = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), mr = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Pe) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), pr = 2;
function gr(e, t) {
  var r = !1, n = !1, i = 0;
  function o() {
    r && (r = !1, e()), n && u();
  }
  function s() {
    mr(o);
  }
  function u() {
    var d = Date.now();
    if (r) {
      if (d - i < pr)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(s, t);
    i = d;
  }
  return u;
}
var br = 20, Rr = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Sr = typeof MutationObserver < "u", yr = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = gr(this.refresh.bind(this), br);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, n = r.indexOf(t);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Je || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Sr ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Je || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, n = r === void 0 ? "" : r, i = Rr.some(function(o) {
        return !!~n.indexOf(o);
      });
      i && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Ct = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var i = n[r];
    Object.defineProperty(e, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, ve = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Pe;
}, Tt = We(0, 0, 0, 0);
function Ae(e) {
  return parseFloat(e) || 0;
}
function bt(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, i) {
    var o = e["border-" + i + "-width"];
    return n + Ae(o);
  }, 0);
}
function wr(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, i = t; n < i.length; n++) {
    var o = i[n], s = e["padding-" + o];
    r[o] = Ae(s);
  }
  return r;
}
function _r(e) {
  var t = e.getBBox();
  return We(0, 0, t.width, t.height);
}
function Er(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return Tt;
  var n = ve(e).getComputedStyle(e), i = wr(n), o = i.left + i.right, s = i.top + i.bottom, u = Ae(n.width), d = Ae(n.height);
  if (n.boxSizing === "border-box" && (Math.round(u + o) !== t && (u -= bt(n, "left", "right") + o), Math.round(d + s) !== r && (d -= bt(n, "top", "bottom") + s)), !xr(e)) {
    var f = Math.round(u + o) - t, p = Math.round(d + s) - r;
    Math.abs(f) !== 1 && (u -= f), Math.abs(p) !== 1 && (d -= p);
  }
  return We(i.left, i.top, u, d);
}
var Mr = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof ve(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof ve(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function xr(e) {
  return e === ve(e).document.documentElement;
}
function Or(e) {
  return Je ? Mr(e) ? _r(e) : Er(e) : Tt;
}
function zr(e) {
  var t = e.x, r = e.y, n = e.width, i = e.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(o.prototype);
  return Ct(s, {
    x: t,
    y: r,
    width: n,
    height: i,
    top: r,
    right: t + n,
    bottom: i + r,
    left: t
  }), s;
}
function We(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var Cr = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = We(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Or(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), Tr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      var n = zr(r);
      Ct(this, { target: t, contentRect: n });
    }
    return e;
  }()
), Dr = (
  /** @class */
  function() {
    function e(t, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new zt(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof ve(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new Cr(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof ve(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new Tr(n.target, n.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Dt = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new zt(), Lt = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = yr.getInstance(), n = new Dr(t, r, this);
      Dt.set(this, n);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  Lt.prototype[e] = function() {
    var t;
    return (t = Dt.get(this))[e].apply(t, arguments);
  };
});
var Lr = function() {
  return typeof Pe.ResizeObserver < "u" ? Pe.ResizeObserver : Lt;
}(), ee = /* @__PURE__ */ new Map();
function Ht(e) {
  e.forEach(function(t) {
    var r, n = t.target;
    (r = ee.get(n)) === null || r === void 0 || r.forEach(function(i) {
      return i(n);
    });
  });
}
var It = new Lr(Ht);
process.env.NODE_ENV;
process.env.NODE_ENV;
function Hr(e, t) {
  ee.has(e) || (ee.set(e, /* @__PURE__ */ new Set()), It.observe(e)), ee.get(e).add(t);
}
function Ir(e, t) {
  ee.has(e) && (ee.get(e).delete(t), ee.get(e).size || (It.unobserve(e), ee.delete(e)));
}
var kr = /* @__PURE__ */ function(e) {
  or(r, e);
  var t = ar(r);
  function r() {
    return Ot(this, r), t.apply(this, arguments);
  }
  return xt(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(a.Component);
function Nr(e, t) {
  var r = e.children, n = e.disabled, i = a.useRef(null), o = a.useRef(null), s = a.useContext(Ze), u = typeof r == "function", d = u ? r(i) : r, f = a.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), p = !u && /* @__PURE__ */ a.isValidElement(d) && sr(d), l = p ? d.ref : null, g = ur(l, i), h = function() {
    var y;
    return ke(i.current) || // Support `nativeElement` format
    (i.current && $e(i.current) === "object" ? ke((y = i.current) === null || y === void 0 ? void 0 : y.nativeElement) : null) || ke(o.current);
  };
  a.useImperativeHandle(t, function() {
    return h();
  });
  var b = a.useRef(e);
  b.current = e;
  var c = a.useCallback(function(S) {
    var y = b.current, R = y.onResize, E = y.data, M = S.getBoundingClientRect(), I = M.width, L = M.height, _ = S.offsetWidth, H = S.offsetHeight, T = Math.floor(I), A = Math.floor(L);
    if (f.current.width !== T || f.current.height !== A || f.current.offsetWidth !== _ || f.current.offsetHeight !== H) {
      var j = {
        width: T,
        height: A,
        offsetWidth: _,
        offsetHeight: H
      };
      f.current = j;
      var Z = _ === Math.round(I) ? I : _, J = H === Math.round(L) ? L : H, D = P(P({}, j), {}, {
        offsetWidth: Z,
        offsetHeight: J
      });
      s == null || s(D, S, E), R && Promise.resolve().then(function() {
        R(D, S);
      });
    }
  }, []);
  return a.useEffect(function() {
    var S = h();
    return S && !n && Hr(S, c), function() {
      return Ir(S, c);
    };
  }, [i.current, n]), /* @__PURE__ */ a.createElement(kr, {
    ref: o
  }, p ? /* @__PURE__ */ a.cloneElement(d, {
    ref: g
  }) : d);
}
var kt = /* @__PURE__ */ a.forwardRef(Nr);
process.env.NODE_ENV !== "production" && (kt.displayName = "SingleObserver");
var Pr = "rc-observer-key";
function Ar(e, t) {
  var r = e.children, n = typeof r == "function" ? [r] : Ue(r);
  return process.env.NODE_ENV !== "production" && (n.length > 1 ? mt(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : n.length === 0 && mt(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), n.map(function(i, o) {
    var s = (i == null ? void 0 : i.key) || "".concat(Pr, "-").concat(o);
    return /* @__PURE__ */ a.createElement(kt, tt({}, e, {
      key: s,
      ref: o === 0 ? t : void 0
    }), i);
  });
}
var Fe = /* @__PURE__ */ a.forwardRef(Ar);
process.env.NODE_ENV !== "production" && (Fe.displayName = "ResizeObserver");
Fe.Collection = hr;
var Nt = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.height, n = e.offsetY, i = e.offsetX, o = e.children, s = e.prefixCls, u = e.onInnerResize, d = e.innerProps, f = e.rtl, p = e.extra, l = {}, g = {
    display: "flex",
    flexDirection: "column"
  };
  return n !== void 0 && (l = {
    height: r,
    position: "relative",
    overflow: "hidden"
  }, g = P(P({}, g), {}, F(F(F(F(F({
    transform: "translateY(".concat(n, "px)")
  }, f ? "marginRight" : "marginLeft", -i), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ a.createElement("div", {
    style: l
  }, /* @__PURE__ */ a.createElement(Fe, {
    onResize: function(b) {
      var c = b.offsetHeight;
      c && u && u();
    }
  }, /* @__PURE__ */ a.createElement("div", tt({
    style: g,
    className: Ne(F({}, "".concat(s, "-holder-inner"), s)),
    ref: t
  }, d), o, p)));
});
Nt.displayName = "Filler";
function $r(e) {
  var t = e.children, r = e.setRef, n = a.useCallback(function(i) {
    r(i);
  }, []);
  return /* @__PURE__ */ a.cloneElement(t, {
    ref: n
  });
}
function Wr(e, t, r, n, i, o, s, u) {
  var d = u.getKey;
  return e.slice(t, r + 1).map(function(f, p) {
    var l = t + p, g = s(f, l, {
      style: {
        width: n
      },
      offsetX: i
    }), h = d(f);
    return /* @__PURE__ */ a.createElement($r, {
      key: h,
      setRef: function(c) {
        return o(f, c);
      }
    }, g);
  });
}
function Fr(e, t, r) {
  var n = e.length, i = t.length, o, s;
  if (n === 0 && i === 0)
    return null;
  n < i ? (o = e, s = t) : (o = t, s = e);
  var u = {
    __EMPTY_ITEM__: !0
  };
  function d(b) {
    return b !== void 0 ? r(b) : u;
  }
  for (var f = null, p = Math.abs(n - i) !== 1, l = 0; l < s.length; l += 1) {
    var g = d(o[l]), h = d(s[l]);
    if (g !== h) {
      f = l, p = p || g !== d(s[l + 1]);
      break;
    }
  }
  return f === null ? null : {
    index: f,
    multiple: p
  };
}
function Br(e, t, r) {
  var n = a.useState(e), i = N(n, 2), o = i[0], s = i[1], u = a.useState(null), d = N(u, 2), f = d[0], p = d[1];
  return a.useEffect(function() {
    var l = Fr(o || [], e || [], t);
    (l == null ? void 0 : l.index) !== void 0 && p(e[l.index]), s(e);
  }, [e]), [f];
}
var Rt = (typeof navigator > "u" ? "undefined" : $e(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const Pt = function(e, t, r, n) {
  var i = x(!1), o = x(null);
  function s() {
    clearTimeout(o.current), i.current = !0, o.current = setTimeout(function() {
      i.current = !1;
    }, 50);
  }
  var u = x({
    top: e,
    bottom: t,
    left: r,
    right: n
  });
  return u.current.top = e, u.current.bottom = t, u.current.left = r, u.current.right = n, function(d, f) {
    var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, l = d ? (
      // Pass origin wheel when on the left
      f < 0 && u.current.left || // Pass origin wheel when on the right
      f > 0 && u.current.right
    ) : f < 0 && u.current.top || // Pass origin wheel when on the bottom
    f > 0 && u.current.bottom;
    return p && l ? (clearTimeout(o.current), i.current = !1) : (!l || i.current) && s(), !i.current && l;
  };
};
function Vr(e, t, r, n, i, o, s) {
  var u = x(0), d = x(null), f = x(null), p = x(!1), l = Pt(t, r, n, i);
  function g(R, E) {
    if (U.cancel(d.current), !l(!1, E)) {
      var M = R;
      if (!M._virtualHandled)
        M._virtualHandled = !0;
      else
        return;
      u.current += E, f.current = E, Rt || M.preventDefault(), d.current = U(function() {
        var I = p.current ? 10 : 1;
        s(u.current * I, !1), u.current = 0;
      });
    }
  }
  function h(R, E) {
    s(E, !0), Rt || R.preventDefault();
  }
  var b = x(null), c = x(null);
  function S(R) {
    if (e) {
      U.cancel(c.current), c.current = U(function() {
        b.current = null;
      }, 2);
      var E = R.deltaX, M = R.deltaY, I = R.shiftKey, L = E, _ = M;
      (b.current === "sx" || !b.current && I && M && !E) && (L = M, _ = 0, b.current = "sx");
      var H = Math.abs(L), T = Math.abs(_);
      b.current === null && (b.current = o && H > T ? "x" : "y"), b.current === "y" ? g(R, _) : h(R, L);
    }
  }
  function y(R) {
    e && (p.current = R.detail === f.current);
  }
  return [S, y];
}
function jr(e, t, r, n) {
  var i = a.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, r.id, n]), o = N(i, 2), s = o[0], u = o[1], d = function(p) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : p, g = s.get(p), h = s.get(l);
    if (g === void 0 || h === void 0)
      for (var b = e.length, c = u.length; c < b; c += 1) {
        var S, y = e[c], R = t(y);
        s.set(R, c);
        var E = (S = r.get(R)) !== null && S !== void 0 ? S : n;
        if (u[c] = (u[c - 1] || 0) + E, R === p && (g = c), R === l && (h = c), g !== void 0 && h !== void 0)
          break;
      }
    return {
      top: u[g - 1] || 0,
      bottom: u[h]
    };
  };
  return d;
}
var Yr = /* @__PURE__ */ function() {
  function e() {
    Ot(this, e), F(this, "maps", void 0), F(this, "id", 0), F(this, "diffKeys", /* @__PURE__ */ new Set()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return xt(e, [{
    key: "set",
    value: function(r, n) {
      this.maps[r] = n, this.id += 1, this.diffKeys.add(r);
    }
  }, {
    key: "get",
    value: function(r) {
      return this.maps[r];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffKeys.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffKeys;
    }
  }]), e;
}();
function St(e) {
  var t = parseFloat(e);
  return isNaN(t) ? 0 : t;
}
function Xr(e, t, r) {
  var n = a.useState(0), i = N(n, 2), o = i[0], s = i[1], u = x(/* @__PURE__ */ new Map()), d = x(new Yr()), f = x(0);
  function p() {
    f.current += 1;
  }
  function l() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    p();
    var b = function() {
      u.current.forEach(function(y, R) {
        if (y && y.offsetParent) {
          var E = ke(y), M = E.offsetHeight, I = getComputedStyle(E), L = I.marginTop, _ = I.marginBottom, H = St(L), T = St(_), A = M + H + T;
          d.current.get(R) !== A && d.current.set(R, A);
        }
      }), s(function(y) {
        return y + 1;
      });
    };
    if (h)
      b();
    else {
      f.current += 1;
      var c = f.current;
      Promise.resolve().then(function() {
        c === f.current && b();
      });
    }
  }
  function g(h, b) {
    var c = e(h);
    u.current.get(c), b ? (u.current.set(c, b), l()) : u.current.delete(c);
  }
  return Mt(function() {
    return p;
  }, []), [g, l, d.current, o];
}
var yt = 14 / 15;
function Gr(e, t, r) {
  var n = x(!1), i = x(0), o = x(0), s = x(null), u = x(null), d, f = function(h) {
    if (n.current) {
      var b = Math.ceil(h.touches[0].pageX), c = Math.ceil(h.touches[0].pageY), S = i.current - b, y = o.current - c, R = Math.abs(S) > Math.abs(y);
      R ? i.current = b : o.current = c;
      var E = r(R, R ? S : y, !1, h);
      E && h.preventDefault(), clearInterval(u.current), E && (u.current = setInterval(function() {
        R ? S *= yt : y *= yt;
        var M = Math.floor(R ? S : y);
        (!r(R, M, !0) || Math.abs(M) <= 0.1) && clearInterval(u.current);
      }, 16));
    }
  }, p = function() {
    n.current = !1, d();
  }, l = function(h) {
    d(), h.touches.length === 1 && !n.current && (n.current = !0, i.current = Math.ceil(h.touches[0].pageX), o.current = Math.ceil(h.touches[0].pageY), s.current = h.target, s.current.addEventListener("touchmove", f, {
      passive: !1
    }), s.current.addEventListener("touchend", p, {
      passive: !0
    }));
  };
  d = function() {
    s.current && (s.current.removeEventListener("touchmove", f), s.current.removeEventListener("touchend", p));
  }, ye(function() {
    return e && t.current.addEventListener("touchstart", l, {
      passive: !0
    }), function() {
      var g;
      (g = t.current) === null || g === void 0 || g.removeEventListener("touchstart", l), d(), clearInterval(u.current);
    };
  }, [e]);
}
function wt(e) {
  return Math.floor(Math.pow(e, 0.5));
}
function Qe(e, t) {
  var r = "touches" in e ? e.touches[0] : e;
  return r[t ? "pageX" : "pageY"] - window[t ? "scrollX" : "scrollY"];
}
function Kr(e, t, r) {
  a.useEffect(function() {
    var n = t.current;
    if (e && n) {
      var i = !1, o, s, u = function() {
        U.cancel(o);
      }, d = function g() {
        u(), o = U(function() {
          r(s), g();
        });
      }, f = function(h) {
        var b = h;
        b._virtualHandled || (b._virtualHandled = !0, i = !0);
      }, p = function() {
        i = !1, u();
      }, l = function(h) {
        if (i) {
          var b = Qe(h, !1), c = n.getBoundingClientRect(), S = c.top, y = c.bottom;
          if (b <= S) {
            var R = S - b;
            s = -wt(R), d();
          } else if (b >= y) {
            var E = b - y;
            s = wt(E), d();
          } else
            u();
        }
      };
      return n.addEventListener("mousedown", f), n.ownerDocument.addEventListener("mouseup", p), n.ownerDocument.addEventListener("mousemove", l), function() {
        n.removeEventListener("mousedown", f), n.ownerDocument.removeEventListener("mouseup", p), n.ownerDocument.removeEventListener("mousemove", l), u();
      };
    }
  }, [e]);
}
var _t = 10;
function qr(e, t, r, n, i, o, s, u) {
  var d = a.useRef(), f = a.useState(null), p = N(f, 2), l = p[0], g = p[1];
  return ye(function() {
    if (l && l.times < _t) {
      if (!e.current) {
        g(function($) {
          return P({}, $);
        });
        return;
      }
      o();
      var h = l.targetAlign, b = l.originAlign, c = l.index, S = l.offset, y = e.current.clientHeight, R = !1, E = h, M = null;
      if (y) {
        for (var I = h || b, L = 0, _ = 0, H = 0, T = Math.min(t.length - 1, c), A = 0; A <= T; A += 1) {
          var j = i(t[A]);
          _ = L;
          var Z = r.get(j);
          H = _ + (Z === void 0 ? n : Z), L = H;
        }
        for (var J = I === "top" ? S : y - S, D = T; D >= 0; D -= 1) {
          var se = i(t[D]), B = r.get(se);
          if (B === void 0) {
            R = !0;
            break;
          }
          if (J -= B, J <= 0)
            break;
        }
        switch (I) {
          case "top":
            M = _ - S;
            break;
          case "bottom":
            M = H - y + S;
            break;
          default: {
            var te = e.current.scrollTop, Y = te + y;
            _ < te ? E = "top" : H > Y && (E = "bottom");
          }
        }
        M !== null && s(M), M !== l.lastTop && (R = !0);
      }
      R && g(P(P({}, l), {}, {
        times: l.times + 1,
        targetAlign: E,
        lastTop: M
      }));
    } else process.env.NODE_ENV !== "production" && (l == null ? void 0 : l.times) === _t && cr(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [l, e.current]), function(h) {
    if (h == null) {
      u();
      return;
    }
    if (U.cancel(d.current), typeof h == "number")
      s(h);
    else if (h && $e(h) === "object") {
      var b, c = h.align;
      "index" in h ? b = h.index : b = t.findIndex(function(R) {
        return i(R) === h.key;
      });
      var S = h.offset, y = S === void 0 ? 0 : S;
      g({
        times: 0,
        index: b,
        offset: y,
        originAlign: c
      });
    }
  };
}
var et = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.rtl, i = e.scrollOffset, o = e.scrollRange, s = e.onStartMove, u = e.onStopMove, d = e.onScroll, f = e.horizontal, p = e.spinSize, l = e.containerSize, g = e.style, h = e.thumbStyle, b = a.useState(!1), c = N(b, 2), S = c[0], y = c[1], R = a.useState(null), E = N(R, 2), M = E[0], I = E[1], L = a.useState(null), _ = N(L, 2), H = _[0], T = _[1], A = !n, j = a.useRef(), Z = a.useRef(), J = a.useState(!1), D = N(J, 2), se = D[0], B = D[1], te = a.useRef(), Y = function() {
    clearTimeout(te.current), B(!0), te.current = setTimeout(function() {
      B(!1);
    }, 3e3);
  }, $ = o - l || 0, de = l - p || 0, C = a.useMemo(function() {
    if (i === 0 || $ === 0)
      return 0;
    var V = i / $;
    return V * de;
  }, [i, $, de]), re = function(O) {
    O.stopPropagation(), O.preventDefault();
  }, ue = a.useRef({
    top: C,
    dragging: S,
    pageY: M,
    startTop: H
  });
  ue.current = {
    top: C,
    dragging: S,
    pageY: M,
    startTop: H
  };
  var ce = function(O) {
    y(!0), I(Qe(O, f)), T(ue.current.top), s(), O.stopPropagation(), O.preventDefault();
  };
  a.useEffect(function() {
    var V = function(le) {
      le.preventDefault();
    }, O = j.current, G = Z.current;
    return O.addEventListener("touchstart", V, {
      passive: !1
    }), G.addEventListener("touchstart", ce, {
      passive: !1
    }), function() {
      O.removeEventListener("touchstart", V), G.removeEventListener("touchstart", ce);
    };
  }, []);
  var we = a.useRef();
  we.current = $;
  var he = a.useRef();
  he.current = de, a.useEffect(function() {
    if (S) {
      var V, O = function(le) {
        var me = ue.current, Ee = me.dragging, Me = me.pageY, xe = me.startTop;
        U.cancel(V);
        var Oe = j.current.getBoundingClientRect(), ne = l / (f ? Oe.width : Oe.height);
        if (Ee) {
          var pe = (Qe(le, f) - Me) * ne, ge = xe;
          !A && f ? ge -= pe : ge += pe;
          var ze = we.current, Ce = he.current, Be = Ce ? ge / Ce : 0, q = Math.ceil(Be * ze);
          q = Math.max(q, 0), q = Math.min(q, ze), V = U(function() {
            d(q, f);
          });
        }
      }, G = function() {
        y(!1), u();
      };
      return window.addEventListener("mousemove", O, {
        passive: !0
      }), window.addEventListener("touchmove", O, {
        passive: !0
      }), window.addEventListener("mouseup", G, {
        passive: !0
      }), window.addEventListener("touchend", G, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", O), window.removeEventListener("touchmove", O), window.removeEventListener("mouseup", G), window.removeEventListener("touchend", G), U.cancel(V);
      };
    }
  }, [S]), a.useEffect(function() {
    return Y(), function() {
      clearTimeout(te.current);
    };
  }, [i]), a.useImperativeHandle(t, function() {
    return {
      delayHidden: Y
    };
  });
  var W = "".concat(r, "-scrollbar"), X = {
    position: "absolute",
    visibility: se ? null : "hidden"
  }, K = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return f ? (X.height = 8, X.left = 0, X.right = 0, X.bottom = 0, K.height = "100%", K.width = p, A ? K.left = C : K.right = C) : (X.width = 8, X.top = 0, X.bottom = 0, A ? X.right = 0 : X.left = 0, K.width = "100%", K.height = p, K.top = C), /* @__PURE__ */ a.createElement("div", {
    ref: j,
    className: Ne(W, F(F(F({}, "".concat(W, "-horizontal"), f), "".concat(W, "-vertical"), !f), "".concat(W, "-visible"), se)),
    style: P(P({}, X), g),
    onMouseDown: re,
    onMouseMove: Y
  }, /* @__PURE__ */ a.createElement("div", {
    ref: Z,
    className: Ne("".concat(W, "-thumb"), F({}, "".concat(W, "-thumb-moving"), S)),
    style: P(P({}, K), h),
    onMouseDown: ce
  }));
});
process.env.NODE_ENV !== "production" && (et.displayName = "ScrollBar");
var Ur = 20;
function Et() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = e / t * e;
  return isNaN(r) && (r = 0), r = Math.max(r, Ur), Math.floor(r);
}
var Zr = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], Jr = [], Qr = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function en(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-virtual-list" : r, i = e.className, o = e.height, s = e.itemHeight, u = e.fullHeight, d = u === void 0 ? !0 : u, f = e.style, p = e.data, l = e.children, g = e.itemKey, h = e.virtual, b = e.direction, c = e.scrollWidth, S = e.component, y = S === void 0 ? "div" : S, R = e.onScroll, E = e.onVirtualScroll, M = e.onVisibleChange, I = e.innerProps, L = e.extraRender, _ = e.styles, H = lr(e, Zr), T = a.useCallback(function(m) {
    return typeof g == "function" ? g(m) : m == null ? void 0 : m[g];
  }, [g]), A = Xr(T), j = N(A, 4), Z = j[0], J = j[1], D = j[2], se = j[3], B = !!(h !== !1 && o && s), te = a.useMemo(function() {
    return Object.values(D.maps).reduce(function(m, v) {
      return m + v;
    }, 0);
  }, [D.id, D.maps]), Y = B && p && (Math.max(s * p.length, te) > o || !!c), $ = b === "rtl", de = Ne(n, F({}, "".concat(n, "-rtl"), $), i), C = p || Jr, re = x(), ue = x(), ce = x(), we = Ie(0), he = N(we, 2), W = he[0], X = he[1], K = Ie(0), V = N(K, 2), O = V[0], G = V[1], _e = Ie(!1), le = N(_e, 2), me = le[0], Ee = le[1], Me = function() {
    Ee(!0);
  }, xe = function() {
    Ee(!1);
  }, Oe = {
    getKey: T
  };
  function ne(m) {
    X(function(v) {
      var w;
      typeof m == "function" ? w = m(v) : w = m;
      var z = jt(w);
      return re.current.scrollTop = z, z;
    });
  }
  var pe = x({
    start: 0,
    end: C.length
  }), ge = x(), ze = Br(C, T), Ce = N(ze, 1), Be = Ce[0];
  ge.current = Be;
  var q = a.useMemo(function() {
    if (!B)
      return {
        scrollHeight: void 0,
        start: 0,
        end: C.length - 1,
        offset: void 0
      };
    if (!Y) {
      var m;
      return {
        scrollHeight: ((m = ue.current) === null || m === void 0 ? void 0 : m.offsetHeight) || 0,
        start: 0,
        end: C.length - 1,
        offset: void 0
      };
    }
    for (var v = 0, w, z, k, He = C.length, Se = 0; Se < He; Se += 1) {
      var Jt = C[Se], Qt = T(Jt), ht = D.get(Qt), qe = v + (ht === void 0 ? s : ht);
      qe >= W && w === void 0 && (w = Se, z = v), qe > W + o && k === void 0 && (k = Se), v = qe;
    }
    return w === void 0 && (w = 0, z = 0, k = Math.ceil(o / s)), k === void 0 && (k = C.length - 1), k = Math.min(k + 1, C.length - 1), {
      scrollHeight: v,
      start: w,
      end: k,
      offset: z
    };
  }, [Y, B, W, C, se, o]), oe = q.scrollHeight, fe = q.start, be = q.end, rt = q.offset;
  pe.current.start = fe, pe.current.end = be, a.useLayoutEffect(function() {
    var m = D.getRecord();
    if (m.size === 1) {
      var v = Array.from(m)[0], w = T(C[fe]);
      if (w === v) {
        var z = D.get(v), k = z - s;
        ne(function(He) {
          return He + k;
        });
      }
    }
    D.resetRecord();
  }, [oe]);
  var $t = a.useState({
    width: 0,
    height: o
  }), nt = N($t, 2), Q = nt[0], Wt = nt[1], Ft = function(v) {
    Wt({
      width: v.offsetWidth,
      height: v.offsetHeight
    });
  }, it = x(), ot = x(), Bt = a.useMemo(function() {
    return Et(Q.width, c);
  }, [Q.width, c]), Vt = a.useMemo(function() {
    return Et(Q.height, oe);
  }, [Q.height, oe]), Ve = oe - o, je = x(Ve);
  je.current = Ve;
  function jt(m) {
    var v = m;
    return Number.isNaN(je.current) || (v = Math.min(v, je.current)), v = Math.max(v, 0), v;
  }
  var Te = W <= 0, De = W >= Ve, at = O <= 0, st = O >= c, Yt = Pt(Te, De, at, st), Ye = function() {
    return {
      x: $ ? -O : O,
      y: W
    };
  }, Xe = x(Ye()), Le = pt(function(m) {
    if (E) {
      var v = P(P({}, Ye()), m);
      (Xe.current.x !== v.x || Xe.current.y !== v.y) && (E(v), Xe.current = v);
    }
  });
  function ut(m, v) {
    var w = m;
    v ? (gt.flushSync(function() {
      G(w);
    }), Le()) : ne(w);
  }
  function Xt(m) {
    var v = m.currentTarget.scrollTop;
    v !== W && ne(v), R == null || R(m), Le();
  }
  var Ge = function(v) {
    var w = v, z = c ? c - Q.width : 0;
    return w = Math.max(w, 0), w = Math.min(w, z), w;
  }, Gt = pt(function(m, v) {
    v ? (gt.flushSync(function() {
      G(function(w) {
        var z = w + ($ ? -m : m);
        return Ge(z);
      });
    }), Le()) : ne(function(w) {
      var z = w + m;
      return z;
    });
  }), Kt = Vr(B, Te, De, at, st, !!c, Gt), ct = N(Kt, 2), Ke = ct[0], lt = ct[1];
  Gr(B, re, function(m, v, w, z) {
    var k = z;
    return Yt(m, v, w) ? !1 : !k || !k._virtualHandled ? (k && (k._virtualHandled = !0), Ke({
      preventDefault: function() {
      },
      deltaX: m ? v : 0,
      deltaY: m ? 0 : v
    }), !0) : !1;
  }), Kr(Y, re, function(m) {
    ne(function(v) {
      return v + m;
    });
  }), ye(function() {
    function m(w) {
      var z = Te && w.detail < 0, k = De && w.detail > 0;
      B && !z && !k && w.preventDefault();
    }
    var v = re.current;
    return v.addEventListener("wheel", Ke, {
      passive: !1
    }), v.addEventListener("DOMMouseScroll", lt, {
      passive: !0
    }), v.addEventListener("MozMousePixelScroll", m, {
      passive: !1
    }), function() {
      v.removeEventListener("wheel", Ke), v.removeEventListener("DOMMouseScroll", lt), v.removeEventListener("MozMousePixelScroll", m);
    };
  }, [B, Te, De]), ye(function() {
    if (c) {
      var m = Ge(O);
      G(m), Le({
        x: m
      });
    }
  }, [Q.width, c]);
  var ft = function() {
    var v, w;
    (v = it.current) === null || v === void 0 || v.delayHidden(), (w = ot.current) === null || w === void 0 || w.delayHidden();
  }, vt = qr(re, C, D, s, T, function() {
    return J(!0);
  }, ne, ft);
  a.useImperativeHandle(t, function() {
    return {
      nativeElement: ce.current,
      getScrollInfo: Ye,
      scrollTo: function(v) {
        function w(z) {
          return z && $e(z) === "object" && ("left" in z || "top" in z);
        }
        w(v) ? (v.left !== void 0 && G(Ge(v.left)), vt(v.top)) : vt(v);
      }
    };
  }), ye(function() {
    if (M) {
      var m = C.slice(fe, be + 1);
      M(m, C);
    }
  }, [fe, be, C]);
  var qt = jr(C, T, D, s), Ut = L == null ? void 0 : L({
    start: fe,
    end: be,
    virtual: Y,
    offsetX: O,
    offsetY: rt,
    rtl: $,
    getSize: qt
  }), Zt = Wr(C, fe, be, c, O, Z, l, Oe), Re = null;
  o && (Re = P(F({}, d ? "height" : "maxHeight", o), Qr), B && (Re.overflowY = "hidden", c && (Re.overflowX = "hidden"), me && (Re.pointerEvents = "none")));
  var dt = {};
  return $ && (dt.dir = "rtl"), /* @__PURE__ */ a.createElement("div", tt({
    ref: ce,
    style: P(P({}, f), {}, {
      position: "relative"
    }),
    className: de
  }, dt, H), /* @__PURE__ */ a.createElement(Fe, {
    onResize: Ft
  }, /* @__PURE__ */ a.createElement(y, {
    className: "".concat(n, "-holder"),
    style: Re,
    ref: re,
    onScroll: Xt,
    onMouseEnter: ft
  }, /* @__PURE__ */ a.createElement(Nt, {
    prefixCls: n,
    height: oe,
    offsetX: O,
    offsetY: rt,
    scrollWidth: c,
    onInnerResize: J,
    ref: ue,
    innerProps: I,
    rtl: $,
    extra: Ut
  }, Zt))), Y && oe > o && /* @__PURE__ */ a.createElement(et, {
    ref: it,
    prefixCls: n,
    scrollOffset: W,
    scrollRange: oe,
    rtl: $,
    onScroll: ut,
    onStartMove: Me,
    onStopMove: xe,
    spinSize: Vt,
    containerSize: Q.height,
    style: _ == null ? void 0 : _.verticalScrollBar,
    thumbStyle: _ == null ? void 0 : _.verticalScrollBarThumb
  }), Y && c > Q.width && /* @__PURE__ */ a.createElement(et, {
    ref: ot,
    prefixCls: n,
    scrollOffset: O,
    scrollRange: c,
    rtl: $,
    onScroll: ut,
    onStartMove: Me,
    onStopMove: xe,
    spinSize: Bt,
    containerSize: Q.width,
    horizontal: !0,
    style: _ == null ? void 0 : _.horizontalScrollBar,
    thumbStyle: _ == null ? void 0 : _.horizontalScrollBarThumb
  }));
}
var At = /* @__PURE__ */ a.forwardRef(en);
At.displayName = "List";
const mn = rr(function({
  pagination: t = {
    pageSize: 20,
    offset: 0
  },
  options: r,
  onSelect: n,
  onPaginationChange: i,
  noDataTextKey: o = "no-data",
  search: s
}) {
  const u = fr(), d = x(), [f, p] = Ie(1), l = 300, g = 32;
  Mt(() => {
    p(1);
  }, [s]);
  const h = (c) => {
    Math.abs(c.currentTarget.scrollHeight - c.currentTarget.scrollTop - l) <= 1 && (p(f + 1), i == null || i({
      offset: f * t.pageSize,
      pageSize: t.pageSize
    }));
  }, b = (c) => /* @__PURE__ */ ie(un, { children: /* @__PURE__ */ er(
    an,
    {
      onClick: () => n(c, !c.selected),
      title: c.label,
      currentcolor: c.selected ? 1 : 0,
      children: [
        c.selected && /* @__PURE__ */ ie(rn, { children: /* @__PURE__ */ ie(nr, { margin: 10, children: /* @__PURE__ */ ie(dr, {}) }) }),
        /* @__PURE__ */ ie(nn, { $selected: c.selected ? 1 : 0, children: c.label }),
        /* @__PURE__ */ ie(on, { $selected: c.selected ? 1 : 0, children: c.label })
      ]
    }
  ) });
  return r.length > 0 ? /* @__PURE__ */ ie(
    sn,
    {
      ref: d,
      height: r.length * g > l ? l : r.length * g + 8,
      itemHeight: g,
      itemKey: "value",
      onScroll: h,
      data: r,
      children: b
    }
  ) : /* @__PURE__ */ ie(tn, { children: u.get(o) });
}), tn = ae.div`
  padding: 10px;
`, rn = ae.div`
    position: absolute;
`, nn = ae.div`
    opacity: ${({ $selected: e }) => e ? "0" : "1"};
`, on = ae.div`
    display: ${({ $selected: e }) => e ? "" : "none"};
    position: absolute;
    margin-left: 30px;
    width: calc(100% - 42px);
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
`, an = ae.div`
    background-color: ${(e) => e.currentcolor ? "var(--option-background)" : "transparent"};
    color: ${(e) => e.currentcolor ? "var(--primary)" : "inherit"};
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    flex-grow: 1;
    padding: 5px 12px;
    text-overflow: ellipsis;
    overflow-x: hidden;
    -webkit-transition: background 0.3s ease;
    -o-transition: background 0.3s ease;
    transition: background 0.3s ease;
    white-space: nowrap;
    cursor: pointer;
    position: relative;

    &:hover {
        background-color: var(--option-list-hover-bg);
        color: var(--primary);
    }
`, sn = ae(At)`
    max-height: 302px;
    max-width: 600px;
    overflow-y: auto;
    padding-right: 4px;
`, un = ae.div`
    display: flex;
    line-height: 22px;
`;
export {
  mn as default
};
//# sourceMappingURL=OptionList.js.map
